module.exports = __webpack_public_path__ + "static/media/optionsPushed.0737bbaa.svg";